<template>
  <div class="main-container">
    <tl-header type="h1" class="label input-label margin-t-m">IT declarations</tl-header>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <section>
      <div class="row">
        <div class="col-6">
          <div class="employee-card">
            <div>
              <img src="@/assets/user.svg" alt="actionIcon" />
            </div>
            <div class="card-details">
              <h4>Roxie Schmidt</h4>
              <p class="code">RC1234</p>
              <p>Effective from Aug 2019</p>
              <hr />
              <div class="row margin-t-s margin-b-s">
                <div class="col-6">Potential</div>
                <div class="col-6">Rs. 447503</div>
                <div class="col-6">Actual</div>
                <div class="col-6">Rs. 171042</div>
                <div class="col-6">Gap</div>
                <div class="col-6">Rs. 276460</div>
              </div>
              <hr />
              <p></p>
              <p>Taxable Income : Rs 712783</p>
              <p>Annual Tax: Rs 712783</p>
            </div>
          </div>
        </div>
        <div class="col-6">
          <a href="javascript:void(0)" @click="addDependantDetails()" class="dependent-btn">
            <img src="@/assets/group-5.svg" class="plus-icon" />
            <span>Dependant Details</span>
          </a>
        </div>
      </div>

      <div class="margin-t-m">
        <tl-accordion :active="true">
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Salary &amp; Perks</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActiveSalary}">
                <div class="it_accordHeading d-heading" @click="isActiveSalary = !isActiveSalary">
                  <div class="row">
                    <div class="col-8">Salary</div>
                    <div class="col-4 align-right">Rs. 1,20,000</div>
                  </div>
                </div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <data-table
                          :columns="salaryTableColumns"
                          :tableData="salaryList"
                          :showinrow="false"
                        ></data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActiveDeductions}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveDeductions = !isActiveDeductions"
                >
                  <div class="row">
                    <div class="col-8">Deductions</div>
                    <div class="col-4 align-right">Rs. 1,20,000</div>
                  </div>
                </div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <data-table
                          :columns="salaryTableColumns"
                          :tableData="deductionsList"
                          :withForm="false"
                          :showinrow="false"
                        ></data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActivePerquisites}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActivePerquisites = !isActivePerquisites"
                >
                  <div class="row">
                    <div class="col-8">Perquisites</div>
                    <div class="col-4 align-right">Rs. 1,20,000</div>
                  </div>
                </div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <data-table
                          :columns="salaryTableColumns"
                          :tableData="perksList"
                          :withForm="false"
                          :showinrow="false"
                        ></data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </tl-accordion>

        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Exemption Under Section 10</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActiveHRA}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveHRA = !isActiveHRA"
                >House Rent Allowance</div>
                <div class="accordContent">
                  <div class="row margin-t-m" v-for="(house,index) in Exemption10.HRA" :key="index">
                    <div class="col-6">
                      <div class="d-heading2">House {{index+1}}</div>
                    </div>
                    <div class="col-6" v-if="Exemption10.HRA.length > 1">
                      <a class="delete-btn" @click="deleteHouse(index)">
                        <img src="@/assets/delete.svg" />
                        <span>Delete House</span>
                      </a>
                    </div>
                    <div class="col-12 margin-t-s">
                      <div class="icon">
                        <div class="d-heading2">Owner’s Details</div>
                        <div class="row">
                          <div class="col-4">
                            <txt
                              label="Name"
                              :name="'ownername'+index"
                              placeholder="Name"
                              v-model="house.ownerDetails.name"
                            />
                          </div>
                          <div class="col-4">
                            <txt
                              label="PAN number"
                              :name="'ownerpan'+index"
                              placeholder="BMQPR8328R"
                              v-model="house.ownerDetails.pan_number"
                            />
                          </div>
                          <div class="col-4">
                            <span class="input-label">PAN Card</span>
                            <div class="attach_file">
                              <label class="fileLabel" :for="'pfile'+index">
                                <img src="@/assets/ic-attachment.png" alt />
                                <input
                                  type="file"
                                  :id="'pfile'+index"
                                  @change="uploadPanCard($event.target.files[0], index, 'owner')"
                                />
                              </label>
                            </div>
                            <a
                              :href="house.ownerDetails.pancardUrl"
                              target="_blank"
                            >{{house.ownerDetails.fileName}}</a>
                          </div>
                          <div class="col-4">
                            <txt
                              label="Pincode"
                              :name="'ownerpincode'+index"
                              placeholder="pincode"
                              v-model="house.ownerDetails.pincode"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              label="Address"
                              :name="'owneraddress'+index"
                              placeholder="address"
                              v-model="house.ownerDetails.address"
                            />
                          </div>
                          <div class="col-4">
                            <tl-select
                              label="State / Union Territory"
                              :name="'ownerstate'+index"
                              labelText="state_name"
                              :options="stateList"
                              v-model="house.ownerDetails.state"
                              @change="(val)=> house.ownerDetails.state = val"
                            ></tl-select>
                          </div>
                        </div>

                        <div class="row margin-t-m">
                          <div class="col-12 margin-b-m">
                            <tl-checkbox
                              label="Co- Owner details"
                              :name="'co_owner'+index"
                              v-model="house.ownerDetails.isCoOwner"
                            />
                          </div>
                          <div class="col-4">
                            <txt
                              label="Name"
                              :name="'coownername'+index"
                              placeholder="Name"
                              v-model="house.ownerDetails.cownerDetails.name"
                            />
                          </div>
                          <div class="col-4">
                            <txt
                              label="PAN number"
                              :name="'cownerpan'+index"
                              placeholder="BMQPR8328R"
                              v-model="house.ownerDetails.cownerDetails.pan_number"
                            />
                          </div>
                          <div class="col-4">
                            <span class="input-label">PAN Card</span>
                            <div class="attach_file">
                              <label class="fileLabel" :for="'coownerfile'+index">
                                <img src="@/assets/ic-attachment.png" alt />
                                <input
                                  type="file"
                                  :id="'coownerfile'+index"
                                  @change="uploadPanCard($event.target.files[0], index, 'co-owner')"
                                />
                              </label>
                            </div>
                            <a
                              :href="house.ownerDetails.cownerDetails.pancardUrl"
                              target="_blank"
                            >{{house.ownerDetails.cownerDetails.fileName}}</a>
                          </div>
                          <div class="col-4">
                            <txt
                              label="Pincode"
                              :name="'coownerpincode'+index"
                              placeholder="pincode"
                              v-model="house.ownerDetails.cownerDetails.pincode"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              label="Address"
                              :name="'coowneraddress'+index"
                              placeholder="address"
                              v-model="house.ownerDetails.cownerDetails.address"
                            />
                          </div>
                          <div class="col-4">
                            <tl-select
                              label="State / Union Territory"
                              labelText="state_name"
                              :name="'coownerstate'+index"
                              :options="stateList"
                              v-model="house.ownerDetails.cownerDetails.state"
                              @change="(val) => house.ownerDetails.cownerDetails.state = val"
                            ></tl-select>
                          </div>
                        </div>
                        <div class="row margin-t-m" v-for="(item,idx) in house.rentList" :key="idx">
                          <div class="col-3">
                            <div class="label">
                              <span class="input-label">Rent from</span>
                              <date-picker
                                :value="item.rentFrom"
                                @datevalue="(val)=>item.rentFrom=val"
                                :name="'rentFrom'+index+idx"
                              />
                            </div>
                          </div>
                          <div class="col-2">
                            <div class="label">
                              <span class="input-label">Rent to</span>
                              <date-picker
                                :value="item.rentTo"
                                @datevalue="(val)=>item.rentTo=val"
                                :name="'rentTo'+index+idx"
                              />
                            </div>
                          </div>
                          <div class="col-2">
                            <txt
                              label="Amount"
                              type="number"
                              :name="'rentamount'+index+idx"
                              placeholder="amount"
                              v-model="item.amount"
                            />
                          </div>
                          <div class="col-3">
                            <span class="input-label">Rent Agreement</span>
                            <div class="attach_file">
                              <label class="fileLabel" :for="'agreementfile'+index+idx">
                                <img src="@/assets/ic-attachment.png" alt />
                                <input
                                  type="file"
                                  :id="'agreementfile'+index+idx"
                                  @change="uploadRentAggr($event.target.files[0], index, idx)"
                                />
                              </label>
                            </div>
                            <a :href="item.agreementDoc" target="_blank">{{item.fileName}}</a>
                          </div>
                          <div class="col-2" v-if="house.rentList.length > 1">
                            <a class="delete-btn" @click="deleteDate(index, idx)">
                              <img src="@/assets/delete.svg" />
                              <span>Delete House</span>
                            </a>
                          </div>
                        </div>
                        <div class="row margin-t-m margin-b-l">
                          <div class="col-12">
                            <div class="row-container align-center">
                              <img src="@/assets/group-5.svg" class="Group-5" />
                              <button class="text-green" @click="addMoreDate(index)">Add New Date</button>
                            </div>
                          </div>
                        </div>
                        <div class="row margin-t-m">
                          <div class="col-4">
                            <txt
                              label="Pin code"
                              :name="'pincode'+index"
                              placeholder="pincode"
                              v-model="house.pincode"
                            />
                          </div>
                          <div class="col-4">
                            <span class="inline-flex margin-t-m">
                              <tl-radio
                                label="Metro"
                                :id="'metro'+index"
                                value="metro"
                                :name="'cityType'+index"
                                v-model="house.cityType"
                              ></tl-radio>
                              <tl-radio
                                label="Non-Metro"
                                :id="'non_metro'+index"
                                value="non_metro"
                                :name="'cityType'+index"
                                v-model="house.cityType"
                              ></tl-radio>
                            </span>
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              label="Address"
                              :name="'address'+index"
                              placeholder="address"
                              v-model="house.address"
                            />
                          </div>
                          <div class="col-4">
                            <tl-select
                              label="State / Union Territory"
                              labelText="state_name"
                              :name="'state'+index"
                              :options="stateList"
                              v-model="house.State"
                              @change="(val) => house.State = val"
                            ></tl-select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row margin-t-m margin-b-l">
                    <div class="col-12">
                      <div class="row-container align-center">
                        <img src="@/assets/group-5.svg" class="Group-5" />
                        <button class="text-green" @click="addMoreHouse">Add More House</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- others -->

            <div class="d-payroll__accord">
              <div class="it-payroll__accordBlock" :class="{active: isActiveOthers}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveOthers = !isActiveOthers"
                >Others</div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <data-table
                          :columns="exemptTableColumns"
                          :tableData="Exemption10.others"
                          :showinrow="true"
                          :withForm="false"
                          :showhistory="false"
                          :showdelete="false"
                          @editStart="editRow($event)"
                        >
                          <template v-slot:rowcontent="slotprops">
                            <div>
                              <p
                                v-if="slotprops.value.column.key == 'slno'"
                              >{{slotprops.value.index+1}}</p>
                              <p
                                v-if="slotprops.value.column.key == 'particulars'"
                              >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name: slotprops.value.record.name}}</p>
                              <p
                                v-if="slotprops.value.column.key == 'limits'"
                              >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount : (Object.keys(slotprops.value.record.rule).length ?slotprops.value.record.rule.maximum_limit:null)}}</p>
                              <p v-if="slotprops.value.column.key=='planned'">
                                <txt
                                  type="number"
                                  :disable="true"
                                  :name="'explannedvalue'+slotprops.value.index"
                                  v-model="Exemption10.others[slotprops.value.index].planned"
                                />
                                <!-- <span v-else>-</span> -->
                              </p>
                              <p v-if="slotprops.value.column.key=='actual'">
                                <txt
                                  v-if="slotprops.value.record[slotprops.value.column.key] != null"
                                  type="number"
                                  :disable="true"
                                  :name="'exactualvalue'+slotprops.value.index"
                                  v-model="Exemption10.others[slotprops.value.index].actual"
                                />
                                <span v-else>-</span>
                              </p>
                              <p v-if="slotprops.value.column.key=='proofs'">
                                <a
                                  href="javascript:void(0)"
                                  v-if="slotprops.value.record['file_location']"
                                  @click="openDocModal(Exemption10.others[slotprops.value.index].file_location, 'Section10')"
                                >{{slotprops.value.record['file_location'].length }} attachment</a>
                                <span v-else>-</span>
                              </p>
                            </div>
                          </template>
                        </data-table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </tl-accordion>

        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Previous Employment Details</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <ul class="table-header header-table">
              <li class="table-header-item">Particulars</li>
              <li class="table-header-item">Amount</li>
              <li class="table-header-item">Proofs</li>
              <li class="table-header-item"></li>
            </ul>
            <div class="row-div">
              <ul class="table-row">
                <li class="table-row-item">Salary Income After Section 10</li>
                <li class="table-row-item">
                  <txt
                    type="number"
                    name="salary_income"
                    v-model="previousEmploymentDetails.salary_income.amount"
                  />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.salary_income.location, 'salary-income')"
                  >{{previousEmploymentDetails.salary_income.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="salary_income">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="salary_income"
                      @change="uploadPEProof($event.target.files[0], 'salary_income' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">PT Amount</li>
                <li class="table-row-item">
                  <txt type="number" name="pt" v-model="previousEmploymentDetails.pt.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.pt.location, 'pt')"
                  >{{previousEmploymentDetails.pt.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="pt">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="pt"
                      @change="uploadPEProof($event.target.files[0], 'pt' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">VPF</li>
                <li class="table-row-item">
                  <txt type="number" name="vpf" v-model="previousEmploymentDetails.vpf.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.vpf.location, 'vpf')"
                  >{{previousEmploymentDetails.vpf.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="vpf">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="vpf"
                      @change="uploadPEProof($event.target.files[0], 'vpf' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">PF</li>
                <li class="table-row-item">
                  <txt type="number" name="pf" v-model="previousEmploymentDetails.pf.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.pf.location, 'pf')"
                  >{{previousEmploymentDetails.pf.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="pf">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="pf"
                      @change="uploadPEProof($event.target.files[0], 'pf' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">NPS</li>
                <li class="table-row-item">
                  <txt type="number" name="nps" v-model="previousEmploymentDetails.nps.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.nps.location, 'nps')"
                  >{{previousEmploymentDetails.nps.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="nps">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="nps"
                      @change="uploadPEProof($event.target.files[0], 'nps' )"
                    />
                  </label>
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">Income Tax Deduction</li>
                <li class="table-row-item">
                  <txt type="number" name="tds" v-model="previousEmploymentDetails.tds.amount" />
                </li>
                <li class="table-row-item">
                  <a
                    href="javascript:void(0)"
                    @click="openDocModal(previousEmploymentDetails.tds.location,'tds')"
                  >{{previousEmploymentDetails.tds.location.length}} attachments</a>
                </li>
                <li class="table-row-item text-center">
                  <label class="fileLabel" for="tds">
                    <img src="@/assets/group-5.svg" class="plus-icon" />
                    <input
                      type="file"
                      id="tds"
                      @change="uploadPEProof($event.target.files[0], 'tds' )"
                    />
                  </label>
                </li>
              </ul>
            </div>
          </template>
        </tl-accordion>

        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Deductions Under Section -16</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <ul class="table-header header-table">
              <li class="table-header-item">Particulars</li>
              <li class="table-header-item">Amount</li>
            </ul>
            <div class="row-div">
              <ul class="table-row">
                <li class="table-row-item">Standard Deductions</li>
                <li class="table-row-item">
                  <txt
                    type="number"
                    :disable="true"
                    name="st"
                    v-model="deductionsUnderSection16.sd"
                  />
                </li>
              </ul>
              <ul class="table-row">
                <li class="table-row-item">PT Amount</li>
                <li class="table-row-item">
                  <txt
                    type="number"
                    :disable="true"
                    name="pt"
                    v-model="deductionsUnderSection16.pt"
                  />
                </li>
              </ul>
            </div>
          </template>
        </tl-accordion>
        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Section 24 (Housing Loan)</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="datatable-outer-container">
              <table class="datatable">
                <thead>
                  <tr class="header-row">
                    <th>(i)Interest on housing loan (Self occupied)</th>
                    <th>Planned</th>
                    <th>Actual</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tr
                  v-for="(item, index) in section24.self_occupied.selfOccupied"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt
                      type="number"
                      :name="'soplanned'+index"
                      :disable="true"
                      v-model="item.planned"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      :name="'soactual'+index"
                      v-model="item.actual"
                      @change="sumSelfOccupied()"
                    />
                  </td>
                  <td></td>
                  <td></td>
                </tr>
                <tr class="record-row">
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_planned"
                      :disable="true"
                      v-model="section24.self_occupied.total_planned"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_actual"
                      :disable="true"
                      v-model="section24.self_occupied.total_actual"
                    />
                  </td>
                  <td>
                    <a
                      href="javascript:void(0)"
                      @click="openDocModal(section24.self_occupied.proof, 'self-occupied')"
                    >{{section24.self_occupied.proof.length }} attachment</a>
                  </td>
                  <td>
                    <label class="fileLabel" :for="'sfile'+0">
                      <img src="@/assets/group-5.svg" class="plus-icon" />
                      <input
                        type="file"
                        :id="'sfile'+0"
                        @change="uploadFile($event.target.files[0], 0, 'Section24-self')"
                      />
                    </label>
                  </td>
                </tr>
              </table>
            </div>
            <div class="d-payroll__accord margin-t-m">
              <div class="it-payroll__accordBlock" :class="{active: isActiveHLOthers}">
                <div
                  class="it_accordHeading d-heading"
                  @click="isActiveHLOthers = !isActiveHLOthers"
                >Self - Decaration for Joint Property</div>
                <div class="accordContent">
                  <div class="row">
                    <div class="col-12">
                      <div class="icon">
                        <div class="row">
                          <div class="col-4">
                            <txt
                              label="Name of Joint Holder"
                              name="joint_holder_name"
                              v-model="section24.self_occupied.joint_holder_name"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4">
                            <txt
                              label="Relationship"
                              name="relationship"
                              v-model="section24.self_occupied.relationship"
                            />
                          </div>
                        </div>
                        <div class="row margin-t-s">
                          <div class="col-4 margin-t-s">% of tax benefit claimed by joint Holder</div>
                          <div class="col-4">
                            <txt
                              name="tax_benefit"
                              type="number"
                              v-model="section24.self_occupied.tax_benefit"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-for="(letout, index) in section24.let_out_property" :key="index">
              <div class="row">
                <div class="col-12 align-right" v-if="section24.let_out_property.length > 1">
                  <a class="delete-btn" @click="deleteLetOut(index)">
                    <img src="@/assets/delete.svg" />
                    <span>Delete LetOut Property</span>
                  </a>
                </div>
              </div>
              <div class="datatable-outer-container">
                <table class="datatable">
                  <thead>
                    <tr class="header-row">
                      <th>(ii)Income/loss from house property (Letout)</th>
                      <th>Planned</th>
                      <th>Actual</th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tr v-for="(item, idx) in letout.letOut" :key="idx" class="record-row">
                    <td>{{item.name}}</td>
                    <td>
                      <txt
                        type="number"
                        :name="'loplanned'+idx"
                        :disable="true"
                        v-model="item.planned"
                      />
                    </td>
                    <td>
                      <txt
                        type="number"
                        v-if="!item.isCalculate"
                        :name="'loactual'+idx"
                        v-model="item.actual"
                        @change="sumLetOutActual(index)"
                        :disable="item.isDisabled"
                      />
                      <txt
                        type="number"
                        v-else
                        :name="'loactual'+idx"
                        v-model="item.actual"
                        @change="calculateOther(index, idx, item.name); sumLetOutActual(index)"
                        :disable="item.isDisabled"
                      />
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr class="record-row">
                    <td>
                      <b>Total</b>
                    </td>
                    <td>
                      <txt
                        type="number"
                        :name="'totalletoutPlanned'+index"
                        :disable="true"
                        v-model="letout.total_planned"
                      />
                    </td>
                    <td>
                      <txt
                        type="number"
                        :name="'totalletoutActual'+index"
                        :disable="true"
                        v-model="letout.total_actual"
                      />
                    </td>
                    <td>
                      <a
                        href="javascript:void(0)"
                        @click="openDocModal(letout.proof, index, 'letout')"
                      >{{letout.proof.length }} attachment</a>
                    </td>
                    <td>
                      <label class="fileLabel" :for="'lfile'+index">
                        <img src="@/assets/group-5.svg" class="plus-icon" />
                        <input
                          type="file"
                          :id="'lfile'+index"
                          @change="uploadFile($event.target.files[0], index, 'Section24-letout')"
                        />
                      </label>
                    </td>
                  </tr>
                </table>
              </div>
              <div class="datatable-outer-container">
                <table class="datatable">
                  <tbody>
                    <tr class="record-row">
                      <td>
                        <b>Total Exemption</b>
                        <p>Either 2 Lakhs or (i+ii)</p>
                      </td>
                      <td>
                        <txt type="number" name="totalPlanned" :disable="true" />
                      </td>
                      <td>
                        <txt type="number" name="totalPlanned" :disable="true" />
                      </td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="d-payroll__accord margin-t-m">
                <div class="it-payroll__accordBlock" :class="{active: isActiveHLOthers}">
                  <div
                    class="it_accordHeading d-heading"
                    @click="isActiveHLOthers = !isActiveHLOthers"
                  >Self - Decaration for Joint Property</div>
                  <div class="accordContent">
                    <div class="row">
                      <div class="col-12">
                        <div class="icon">
                          <div class="row">
                            <div class="col-4">
                              <txt
                                label="Name of Joint Holder"
                                :name="'letout_joint_holder_name'+index"
                                v-model="letout.joint_holder_name"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4">
                              <txt
                                label="Relationship"
                                :name="'letout_relationship'+index"
                                v-model="letout.relationship"
                              />
                            </div>
                          </div>
                          <div class="row margin-t-s">
                            <div class="col-4 margin-t-s">% of tax benefit claimed by joint Holder</div>
                            <div class="col-4">
                              <txt
                                type="number"
                                :name="'tax_benefit'+index"
                                v-model="letout.tax_benefit"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-t-m margin-b-l">
              <div class="col-12">
                <div class="row-container align-center">
                  <img src="@/assets/group-5.svg" class="Group-5" />
                  <button class="text-green" @click="addMoreLetOut()">Add More Housing Properties</button>
                </div>
              </div>
            </div>
          </template>
        </tl-accordion>
        <tl-accordion :disabled="!isOtherIncomeAllowed">
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Other Income</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <data-table
              :columns="otherIncTableColumns"
              :tableData="otherIncomeList"
              :withForm="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p v-if="slotprops.value.column.key == 'slno'">{{slotprops.value.index+1}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'particulars'"
                  >{{slotprops.value.record['name']}}</p>
                  <p v-if="slotprops.value.column.key=='planned'">
                    <txt
                      type="number"
                      :disable="true"
                      :name="'oivalue'+slotprops.value.index"
                      v-model="otherIncomeList[slotprops.value.index].planned"
                    />
                  </p>
                  <p v-if="slotprops.value.column.key=='actual'">
                    <txt
                      type="number"
                      :name="'oivalue'+slotprops.value.index"
                      v-model="otherIncomeList[slotprops.value.index].actual"
                    />
                  </p>
                  <p v-if="slotprops.value.column.key == 'proof'">
                    <a
                      href="javascript:void(0)"
                      v-if="slotprops.value.record[slotprops.value.column.key]"
                      @click="openDocModal(otherIncomeList[slotprops.value.index].proof, slotprops.value.index, 'other-income')"
                    >{{slotprops.value.record[slotprops.value.column.key].length }} attachment</a>
                  </p>
                  <p v-if="slotprops.value.column.key == 'action'">
                    <label class="fileLabel" :for="'ofile'+slotprops.value.index">
                      <img src="@/assets/group-5.svg" class="plus-icon" />
                      <input
                        type="file"
                        :id="'ofile'+slotprops.value.index"
                        @change="uploadFile($event.target.files[0], slotprops.value.index, 'otherIncome')"
                      />
                    </label>
                  </p>
                </div>
              </template>
            </data-table>
          </template>
        </tl-accordion>
        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Deduction Under Chapter VI A</div>
              <div class="col-6 align-right">Rs. 3,60,000</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="group-heading">80C</div>
            <data-table
              :columns="chapterTableColumns"
              :tableData="chapterDataList"
              :withForm="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p
                    v-if="slotprops.value.column.key == 'group'"
                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.abbreviation: slotprops.value.record.display_group}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'description'"
                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name : slotprops.value.record.name}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'maxLimit'"
                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount: slotprops.value.record.rule.maximum_limit}}</p>
                  <p v-if="slotprops.value.column.key=='planned'">
                    <txt
                      type="number"
                      :disable="true"
                      :name="'dvalue'+slotprops.value.index"
                      v-model="chapterDataList[slotprops.value.index].planned"
                    />
                  </p>
                  <p v-if="slotprops.value.column.key=='actual'">
                    <txt
                      type="number"
                      :name="'dvalue'+slotprops.value.index"
                      v-model="chapterDataList[slotprops.value.index].actual"
                    />
                  </p>
                  <p v-if="slotprops.value.column.key=='proof'">
                    <a
                      href="javascript:void(0)"
                      v-if="slotprops.value.record['file_location']"
                      @click="openDocModal(chapterDataList[slotprops.value.index].file_location, slotprops.value.index, 'chapter-80C')"
                    >{{slotprops.value.record['file_location'].length }} attachment</a>
                    <span v-else>-</span>
                  </p>
                  <p v-if="slotprops.value.column.key == 'action'">
                    <label class="fileLabel" :for="'cfile'+slotprops.value.index">
                      <img src="@/assets/group-5.svg" class="plus-icon" />
                      <input
                        type="file"
                        :id="'cfile'+slotprops.value.index"
                        @change="uploadFile($event.target.files[0], slotprops.value.index, 'chapterVIA')"
                      />
                    </label>
                  </p>
                </div>
              </template>
            </data-table>
            <div class="group-heading margin-t-m">Others</div>
            <data-table
              :columns="chapterTableColumns"
              :tableData="chapterOtherDataList"
              :withForm="false"
              :showinrow="false"
            >
              <template v-slot:rowcontent="slotprops">
                <div>
                  <p
                    v-if="slotprops.value.column.key == 'group'"
                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.abbreviation: slotprops.value.record.display_group}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'description'"
                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.name : slotprops.value.record.name}}</p>
                  <p
                    v-if="slotprops.value.column.key == 'maxLimit'"
                  >{{slotprops.value.record.InvestmentComponentType ? slotprops.value.record.InvestmentComponentType.maximumAmount: slotprops.value.record.rule.maximum_limit}}</p>
                  <p v-if="slotprops.value.column.key=='planned'">
                    <txt
                      type="number"
                      :disable="true"
                      :name="'ovalue'+slotprops.value.index"
                      v-model="chapterOtherDataList[slotprops.value.index].planned"
                    />
                  </p>
                  <p v-if="slotprops.value.column.key=='actual'">
                    <txt
                      type="number"
                      :name="'dvalue'+slotprops.value.index"
                      v-model="chapterOtherDataList[slotprops.value.index].actual"
                    />
                  </p>
                  <p v-if="slotprops.value.column.key=='proof'">
                    <a
                      href="javascript:void(0)"
                      v-if="slotprops.value.record['file_location']"
                      @click="openDocModal(chapterOtherDataList[slotprops.value.index].file_location, slotprops.value.index, 'chapter-others')"
                    >{{slotprops.value.record['file_location'].length }} attachment</a>
                    <span v-else>-</span>
                  </p>
                  <p v-if="slotprops.value.column.key == 'action'">
                    <label class="fileLabel" :for="'cofile'+slotprops.value.index">
                      <img src="@/assets/group-5.svg" class="plus-icon" />
                      <input
                        type="file"
                        :id="'cofile'+slotprops.value.index"
                        @change="uploadFile($event.target.files[0], slotprops.value.index, 'chapterVIAOthers')"
                      />
                    </label>
                  </p>
                </div>
              </template>
            </data-table>
          </template>
        </tl-accordion>
        <tl-accordion>
          <template v-slot:accordionHeader>
            <div class="row">
              <div class="col-6">Taxable Income and TDS Breakup</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.amount}}</div>
            </div>
          </template>
          <template v-slot:accordionBody>
            <div class="group-heading row">
              <div class="col-6">i) Taxable Income</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.taxable_income}}</div>
            </div>
            <div class="group-heading row">
              <div class="col-6">ii) Taxable Income round off to nearest 10 rupees</div>
              <div
                class="col-6 align-right"
              >Rs. {{tds_breakup_and_taxable_income.taxable_income_roundoff}}</div>
            </div>
            <div class="group-heading row">
              <div class="col-6">iii) Total Tax To be Paid</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.total_tax_paid}}</div>
            </div>
            <div class="datatable-outer-container row">
              <table class="datatable">
                <tr
                  v-for="(item, index) in tds_breakup_and_taxable_income.totalTax"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt
                      type="number"
                      :name="'tdsamount'+index"
                      v-model="item.amount"
                      :disable="true"
                    />
                  </td>
                </tr>
                <tr class="record-row">
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_tdsamount"
                      :disable="true"
                      v-model="tds_breakup_and_taxable_income.total_tdsamount"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="group-heading row">
              <div class="col-6">iv) Paid till Date</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.paid_till_date}}</div>
            </div>
            <div class="datatable-outer-container row">
              <table class="datatable">
                <thead>
                  <tr class="header-row">
                    <th></th>
                    <th>Tax</th>
                    <th>Surcharge</th>
                    <th>Edu. Cess</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tr
                  v-for="(item, index) in tds_breakup_and_taxable_income.tdsPaid"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt type="number" :name="'tax'+index" v-model="item.tax" :disable="true" />
                  </td>
                  <td>
                    <txt
                      type="number"
                      :name="'surcharge'+index"
                      v-model="item.surcharge"
                      :disable="true"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      :name="'educess'+index"
                      v-model="item.edu_cess"
                      :disable="true"
                    />
                  </td>
                  <td>
                    <txt type="number" :name="'total'+index" v-model="item.total" :disable="true" />
                  </td>
                </tr>
                <tr class="record-row">
                  <td>
                    <b>Total</b>
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_tax"
                      :disable="true"
                      v-model="tds_breakup_and_taxable_income.total_tax"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_surcharge"
                      :disable="true"
                      v-model="tds_breakup_and_taxable_income.total_surcharge"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_educess"
                      :disable="true"
                      v-model="tds_breakup_and_taxable_income.total_edu_cess"
                    />
                  </td>
                  <td>
                    <txt
                      type="number"
                      name="total_total"
                      :disable="true"
                      v-model="tds_breakup_and_taxable_income.total_total"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="group-heading row">
              <div class="col-6">v) Balance Tax Payable/Refund</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.balance_tax}}</div>
            </div>
            <div class="group-heading row">
              <div class="col-6">vi) Balance Payable ( in 1 installments ) - Income Tax</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.balance_tax_one}}</div>
            </div>
            <div class="group-heading row">
              <div class="col-6">vii) Current Month Tax Deduction</div>
              <div class="col-6 align-right">Rs. {{tds_breakup_and_taxable_income.curren_month_tax}}</div>
            </div>
            <div class="datatable-outer-container row">
              <table class="datatable">
                <tr
                  v-for="(item, index) in tds_breakup_and_taxable_income.currentMonthTax"
                  :key="index"
                  class="record-row"
                >
                  <td>{{item.name}}</td>
                  <td>
                    <txt
                      type="number"
                      :name="'tdsamount'+index"
                      v-model="item.amount"
                      :disable="true"
                    />
                  </td>
                </tr>
              </table>
            </div>
          </template>
        </tl-accordion>
      </div>
    </section>
    <div class="modal custom-modal" v-if="showDocModal">
      <div class="modal-content modal-md">
        <div class="modal-header">
          <div class="row">
            <div class="col-12">
              <h3>Documents</h3>
            </div>
          </div>
        </div>
        <div class="modal-body">
          <div class="carousel">
            <img :src="docUrl" alt class="docImage" />
            <a href="javascript:void(0)" @click="prev()" class="arrow arrow-prev">&lt;</a>
            <a href="javascript:void(0)" @click="next()" class="arrow arrow-next">&gt;</a>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row">
            <div class="col-6 text-left">
              <a
                href="javascript:void(0)"
                v-if="showDeleteDoc"
                class="close-btn"
                @click="deleteDoc(index)"
              >Delete</a>
            </div>
            <div class="col-6">
              <a :href="docUrl" download="file" class="close-btn">
                <img src="@/assets/download.svg" class="img" />
                <span class="text">Download</span>
              </a>
              <btn text="Close" type="secondary" class="btn-close" @click="okbtn" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <bottom-action-container>
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="back" />
          <btn text="Save" type="primary" @click="submitData" />
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import {
  get_axios_file_instance,
  api_variables,
  errorHandler
} from "@/apis/variables.js";
import { commonData } from "../../../../../../../apis/constants.js";

var axios_instance = get_axios_file_instance(api_variables.SERVICE_UPLOAD_LOGO);
export default {
  data() {
    return {
      accordionIndex: 0,
      employeeData: {},
      showModal: false,
      isActiveSalary: true,
      isActiveDeductions: true,
      isActivePerquisites: true,
      isActiveHRA: true,
      isActiveOthers: true,
      isActiveHLOthers: true,
      showDocModal: false,
      errmsg: "",
      toast: false,
      showDeleteDoc: true,
      currentDocIndex: null,
      currentFileSection: "",
      docsList: [],
      stateList: [],
      Exemption10: {
        HRA: [
          {
            address: "",
            pincode: "",
            State: "",
            cityType: "metro",
            rentList: [
              {
                rentFrom: "",
                rentTo: "",
                amount: 0,
                agreementDoc: "",
                fileName: ""
              }
            ],
            ownerDetails: {
              name: "",
              pan_number: "",
              pincode: "",
              address: "",
              state: "",
              pancardUrl: "",
              fileName: "",
              isCoOwner: false,
              cownerDetails: {
                name: "",
                pan_number: "",
                pincode: "",
                address: "",
                state: "",
                pancardUrl: "",
                fileName: ""
              }
            }
          }
        ],
        others: []
      },
      exemptTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Yearly limits",
          key: "limits"
        },
        {
          label: "Planned",
          key: "planned"
        },
        {
          label: "Actual",
          key: "actual"
        },
        {
          label: "Proofs",
          key: "proofs"
        },
        {
          label: "",
          key: "action"
        }
      ],
      previousEmploymentDetails: {
        salary_income: { amount: 0, location: [] },
        pt: { amount: 0, location: [] },
        vpf: { amount: 0, location: [] },
        pf: { amount: 0, location: [] },
        nps: { amount: 0, location: [] },
        tds: { amount: 0, location: [] }
      },
      section24: {
        let_out_property: [
          {
            letOut: [],
            total_planned: 0,
            total_actual: 0,
            total_approved: 0,
            proof: [],
            joint_holder_name: "",
            relationship: "",
            tax_benefit: 0
          }
        ],
        self_occupied: {
          selfOccupied: [],
          total_planned: 0,
          total_actual: 0,
          total_approved: 0,
          proof: [],
          joint_holder_name: "",
          relationship: "",
          tax_benefit: 0
        }
      },
      deductionsUnderSection16: {
        sd: 0,
        pt: 0
      },
      otherIncomeList: [
        {
          name: "Interest From saving Accounts",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        },
        {
          name: "Interest From Fixed Deposits",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        },
        {
          name: "Any other Income",
          value: 123456,
          proof: [],
          actual: 0,
          planned: 0,
          approved: 0,
          file_location: "",
          status: "",
          type: ""
        }
      ],
      chapterTableColumns: [
        {
          label: "Group",
          key: "group"
        },
        {
          label: "Description",
          key: "description"
        },
        {
          label: "Max. Limit",
          key: "maxLimit"
        },
        {
          label: "Planned",
          key: "planned"
        },
        {
          label: "Actual",
          key: "actual"
        },
        {
          label: "Proof",
          key: "proof"
        },
        {
          label: "",
          key: "action"
        }
      ],
      chapterDataList: [],
      chapterOtherDataList: [],
      preEmpDetailsTableColumns: [
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Amount",
          key: "amount"
        },
        {
          label: "Proofs",
          key: "proofs"
        },
        {
          label: "",
          key: "action"
        }
      ],
      preEmpDetails: [
        {
          particulars: "Salary Income After Section 10",
          amount: 0,
          proofs: []
        },
        {
          particulars: "PT Amount",
          amount: 0,
          proofs: []
        }
      ],
      otherIncTableColumns: [
        {
          label: "SL No.",
          key: "slno"
        },
        {
          label: "Particulars",
          key: "particulars"
        },
        {
          label: "Planned",
          key: "planned"
        },
        {
          label: "Actual",
          key: "actual"
        },
        {
          label: "Proofs",
          key: "proof"
        },
        {
          label: "",
          key: "action"
        }
      ],

      salaryTableColumns: [],
      deductionsList: [],
      perksList: [],
      salaryList: [],
      TDSTableColumns: [
        {
          label: "",
          key: "heading"
        },
        {
          label: "Tax",
          key: "tax"
        },
        {
          label: "Surcharge",
          key: "surcharge"
        },
        {
          label: "Edu. Cess",
          key: "edu_cess"
        },
        {
          label: "Total",
          key: "total"
        }
      ],
      tds_breakup_and_taxable_income: {
        amount: 0,
        total_tdsamount: 0,
        total_tax: 0,
        total_surcharge: 0,
        total_edu_cess: 0,
        total_total: 0,
        taxable_income: 0,
        taxable_income_roundoff: 0,
        balance_tax: 0,
        balance_tax_one: 0,
        curren_month_tax: 0,
        paid_till_date: 0,
        total_tax_paid: 0,
        totalTax: [
          {
            name: "Actual Tax",
            amount: 0
          },
          {
            name: "Tax Rebate",
            amount: 0
          },
          {
            name: "Tax",
            amount: 0
          },
          {
            name: "Surcharge ",
            amount: 0
          },
          {
            name: "Edu. Cess",
            amount: 0
          }
        ],
        tdsPaid: [
          {
            name: "Deduction Through",
            tax: 0,
            surcharge: 0,
            edu_cess: 0,
            total: 0
          },
          {
            name: "Payroll",
            tax: 0,
            surcharge: 0,
            edu_cess: 0,
            total: 0
          },
          {
            name: "Direct TDS",
            tax: 0,
            surcharge: 0,
            edu_cess: 0,
            total: 0
          },
          {
            name: "Pervious Employment",
            tax: 0,
            surcharge: 0,
            edu_cess: 0,
            total: 0
          }
        ],
        currentMonthTax: [
          {
            name: " Regular Tax",
            amount: 0
          },
          {
            name: "One Time Tax",
            amount: 0
          },
          {
            name: "Total for the month",
            amount: 0
          }
        ]
      },
      relationList: commonData.relationshipList,
      rentFrom: "",
      rentTo: "",
      docUrl: "",
      index: 0,
      isOtherIncomeAllowed: false
    };
  },
  computed: {
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    ...mapState("dashboard/organisation/utilities/itdeclarations", {
      ltaData: state => state.LTA,
      driverData: state => state.DS,
      trData: state => state.TR,
      irData: state => state.IR,
      bpData: state => state.BP,
      ceaData: state => state.CEA,
      hfaData: state => state.HFA,
      raData: state => state.RA,
      pdData: state => state.PD,
      fnmData: state => state.FNM,
      beData: state => state.BE,
      dependentData: state => state.dependentData
    }),
    ...mapState({
      incomeTaxData: state => state.onboard.statutoryinfo.incometax.data,
      globalData: state => state.globalapi.globalData.data
    })
  },
  activated() {
    if (this.incomeTaxData[this.le_id]) {
      let obj = this.incomeTaxData[this.le_id].itSettings;
      if (obj.declareOtherIncome) {
        this.isOtherIncomeAllowed = true;
      } else {
        this.isOtherIncomeAllowed = false;
      }
    }
    this.setGolbalData();
    this.calculateSalaryColumns();
    this.calculatFY();
    this.calculateLetOutFy();
    this.getITDeclarationsData();
  },
  mounted() {},
  methods: {
    ...mapActions({
      act_fetchITDeclarationData:
        "dashboard/organisation/utilities/itdeclarations/fetchITDeclaration",
      act_submitITDeclarationData:
        "dashboard/organisation/utilities/itdeclarations/create",
      saveData: "dashboard/organisation/utilities/itdeclarations/saveLTA",
      saveTRData: "dashboard/organisation/utilities/itdeclarations/saveTR",
      saveIRData: "dashboard/organisation/utilities/itdeclarations/saveIR",
      saveDSData: "dashboard/organisation/utilities/itdeclarations/saveDS",
      saveBPData: "dashboard/organisation/utilities/itdeclarations/saveBP",
      saveCEAData: "dashboard/organisation/utilities/itdeclarations/saveCEA",
      saveHFAData: "dashboard/organisation/utilities/itdeclarations/saveHFA",
      saveRAData: "dashboard/organisation/utilities/itdeclarations/saveRA",
      savePDData: "dashboard/organisation/utilities/itdeclarations/savePD",
      saveFNMData: "dashboard/organisation/utilities/itdeclarations/saveFNM",
      saveBEData: "dashboard/organisation/utilities/itdeclarations/saveBE"
    }),
    setGolbalData() {
      try {
        this.stateList = this.globalData
          ? this.globalData.State
            ? this.globalData.State
            : []
          : [];
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculateSalaryColumns() {
      try {
        let d = new Date();
        let year = d.getFullYear();
        let next_year = (year + 1).toString().slice(2, 4);
        let last_two_digits = year.toString().slice(2, 4);
        this.salaryTableColumns = [
          {
            label: "Particulars",
            key: "name"
          },
          {
            label: "Apr",
            key: "apr"
          },
          {
            label: "May",
            key: "may"
          },
          {
            label: "Jun",
            key: "jun"
          },
          {
            label: "Jul",
            key: "jul"
          },

          {
            label: "Aug",
            key: "aug"
          },
          {
            label: "Sep",
            key: "sept"
          },
          {
            label: "Oct",
            key: "oct"
          },
          {
            label: "Nov",
            key: "nov"
          },
          {
            label: "Dec",
            key: "dec"
          },
          {
            label: "Jan",
            key: "jan"
          },
          {
            label: "Feb",
            key: "feb"
          },
          {
            label: "Mar",
            key: "mar"
          }
        ];
        this.salaryTableColumns.forEach((element, index) => {
          if (index) {
            if (index < 10) {
              element.label = element.label + "'" + last_two_digits;
            } else {
              element.label = element.label + "'" + next_year;
            }
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculatFY() {
      try {
        let d = new Date();
        let year = d.getFullYear();
        this.section24.self_occupied.selfOccupied = [
          {
            name: "Current Year Interest",
            planned: 0,
            actual: 0
          }
        ];
        for (let i = 1; i <= 5; i++) {
          let next_year = year - i;
          this.section24.self_occupied.selfOccupied.push({
            name: "Pre EMI Interest " + (year - i + "-" + (next_year + 1)),
            planned: 0,
            actual: 0
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculateLetOutFy() {
      try {
        let d = new Date();
        let year = d.getFullYear();

        this.section24.let_out_property.forEach(element => {
          element.letOut = [
            {
              name: "Current Year Interest",
              planned: 0,
              actual: 0,
              approved: 0
            }
          ];
          for (let i = 1; i <= 5; i++) {
            element.letOut.push({
              name: "Pre EMI Interest FY" + i,
              planned: 0,
              actual: 0,
              approved: 0
            });
          }
          element.letOut.push(
            {
              name: "A Total rent received by employee",
              planned: 0,
              actual: 0,
              approved: 0,
              isCalculate: true
            },
            {
              name: "B Less: municipal Taxes Paid",
              planned: 0,
              actual: 0,
              approved: 0,
              isCalculate: true
            },
            {
              name: "C (A-B) Net Annual Value",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "D (C* 30%) Less: Standard Deduction @ 30%",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "E Less: Interest on Housing Loan",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            },
            {
              name: "F (C-D-E) Income/Loss on House Property",
              planned: 0,
              actual: 0,
              approved: 0,
              isDisabled: true
            }
          );
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    calculateOther(letOutIndex, rowIndex, name) {
      try {
        let obj1 = {};
        let index = 0;
        let obj2 = {};
        if (name == "A Total rent received by employee") {
          index = rowIndex + 2;
          obj2 = this.section24.let_out_property[letOutIndex].letOut[
            rowIndex + 1
          ];
          obj1 = this.section24.let_out_property[letOutIndex].letOut[rowIndex];
        } else {
          index = rowIndex + 1;
          obj2 = this.section24.let_out_property[letOutIndex].letOut[rowIndex];
          obj1 = this.section24.let_out_property[letOutIndex].letOut[
            rowIndex - 1
          ];
        }
        this.section24.let_out_property[letOutIndex].letOut[index].actual =
          obj1.actual - obj2.actual;
        this.section24.let_out_property[letOutIndex].letOut[index + 1].actual =
          (30 *
            this.section24.let_out_property[letOutIndex].letOut[index].actual) /
          100;
        this.section24.let_out_property[letOutIndex].letOut[index + 3].actual =
          this.section24.let_out_property[letOutIndex].letOut[index].actual -
          this.section24.let_out_property[letOutIndex].letOut[index + 1]
            .actual -
          this.section24.let_out_property[letOutIndex].letOut[index + 2].actual;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumSelfOccupied() {
      try {
        let sum = 0;
        this.section24.self_occupied.selfOccupied.forEach(element => {
          sum += element.actual;
        });
        this.section24.self_occupied.total_actual = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    sumLetOutActual(index) {
      try {
        let sum = 0;
        this.section24.let_out_property[index].letOut.forEach(item => {
          sum += item.actual;
        });
        this.section24.let_out_property[index].total_actual = sum;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    editRow(record) {
      try {
        let isActual = record.InvestmentComponentType ? true : false;
        let ictName = isActual ? record.InvestmentComponentType.name : "";
        if (
          (isActual && ictName == "Leave Travel Allowance (LTA)") ||
          record.name == "Leave Travel Allowance (LTA)"
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/income_tax_lta`,
            query: { id: this.$route.query.id }
          });
        }
        if (
          (isActual &&
            (ictName == "Telephone Reimbursement" ||
              ictName == "Internet Reimbursement")) ||
          record.name == "Telephone Reimbursement" ||
          record.name == "Internet Reimbursement"
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/telephone_reimbursement`,
            query: {
              id: this.$route.query.id,
              page: isActual ? ictName : record.name
            }
          });
        }
        if (
          (isActual && ictName == "Vehicle Maintenance") ||
          record.name == "Vehicle Maintenance"
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/vehicle_maintenance`,
            query: { id: this.$route.query.id }
          });
        }
        if (
          (isActual && ictName == "Driver Salary Reimbursement") ||
          record.name == "Driver Salary Reimbursement"
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/driver_salary`,
            query: { id: this.$route.query.id }
          });
        }
        if (
          (isActual && ictName == "Books & Periodicals") ||
          record.name == "Books & Periodicals"
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/periodical`,
            query: { id: this.$route.query.id }
          });
        }
        if (
          (isActual &&
            (ictName == "Relocation Allowance" ||
              ictName == "Professional Development" ||
              ictName == "Fuel & Maintenance Reimbursement" ||
              ictName == "Business Entertainment")) ||
          record.name == "Relocation Allowance" ||
          record.name == "Professional Development" ||
          record.name == "Fuel & Maintenance Reimbursement" ||
          record.name == "Business Entertainment"
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/relocation`,
            query: {
              id: this.$route.query.id,
              page: isActual ? ictName : record.name
            }
          });
        }
        if (
          (isActual &&
            (ictName == "Children Education Allowance" ||
              ictName == "Hostel Fee Allowance")) ||
          record.name == "Children Education Allowance" ||
          record.name == "Hostel Fee Allowance"
        ) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/children_education`,
            query: {
              id: this.$route.query.id,
              page: isActual ? ictName : record.name
            }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    async getITDeclarationsData() {
      try {
        let res = await this.act_fetchITDeclarationData({
          le_id: this.le_id,
          emp_id: this.$route.query.id,
          fy: 2019
        });
        if (res.data.status) {
          this.salaryList = [];
          this.deductionsList = [];
          this.perksList = [];
          let obj = res.data.payload;
          for (const key in obj.Salary.earnings) {
            if (obj.Salary.earnings.hasOwnProperty(key)) {
              let compObj = Object.assign({}, ...obj.Salary.earnings[key]);
              this.salaryList.push({
                name: key,
                ...compObj
              });
            }
          }
          for (const key in obj.Salary.deductions) {
            if (obj.Salary.deductions.hasOwnProperty(key)) {
              let compObj = Object.assign({}, ...obj.Salary.deductions[key]);
              this.deductionsList.push({
                name: key,
                ...compObj
              });
            }
          }
          for (const key in obj.Salary.perks) {
            if (obj.Salary.perks.hasOwnProperty(key)) {
              let compObj = Object.assign({}, ...obj.Salary.perks[key]);
              this.perksList.push({
                name: key,
                ...compObj
              });
            }
          }
          this.chapterDataList = [];
          this.chapterOtherDataList = [];
          obj.deductionsUnderChapterVIA.forEach(element => {
            if (
              element.display_group == "80C" ||
              (element.InvestmentComponentType &&
                element.InvestmentComponentType.abbreviation == "80C")
            ) {
              this.chapterDataList.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
              });
            } else {
              this.chapterOtherDataList.push({
                planned: element.planned ? element.planned : 0,
                actual: element.actual ? element.actual : 0,
                ...element
              });
            }
          });
          this.Exemption10.others = [];
          obj.Exemption10.others.forEach(element => {
            this.Exemption10.others.push({
              planned: element.planned ? element.planned : 0,
              actual: element.actual ? element.actual : 0,
              ...element
            });
          });
          if (obj.Exemption10.HRA.length) {
            this.Exemption10.HRA = obj.Exemption10.HRA;
          }
          this.deductionsUnderSection16 = obj.deductionsUnderSection16;
          if (obj.otherIncome.length) {
            this.otherIncomeList = obj.otherIncome;
          }
          if (Object.keys(obj.previousEmploymentDetails).length) {
            this.previousEmploymentDetails = obj.previousEmploymentDetails;
          }
          if (Object.keys(obj.section24).length) {
            if (obj.section24.let_out_property.length) {
              this.section24.let_out_property = obj.section24.let_out_property;
            }
            this.section24.self_occupied = obj.section24.self_occupied;
          }
          this.setLTAData();
          this.setTRData();
          this.setIRData();
          this.setDSData();
          this.setBPData();
          this.setCEAData();
          this.setHFAData();
          this.setRAData();
          this.setPDData();
          this.setBEData();
          this.setFNMData();
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveLTA(obj) {
      await this.saveData(obj);
    },
    setLTAData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name ==
              "Leave Travel Allowance (LTA)"
            : element.name == "Leave Travel Allowance (LTA)"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveLTA(obj.details);
        } else if (this.ltaData && this.ltaData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name ==
                "Leave Travel Allowance (LTA)"
              : element.name == "Leave Travel Allowance (LTA)"
          );
          this.Exemption10.others[index].file_location = this.ltaData[
            this.$route.query.id
          ].lta_data.proofs;

          let sum = 0;
          this.ltaData[this.$route.query.id].lta_data.dependent.forEach(
            element => {
              sum += element.amount;
            }
          );
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.ltaData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveTR(obj) {
      await this.saveTRData(obj);
    },
    setTRData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name == "Telephone Reimbursement"
            : element.name == "Telephone Reimbursement"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveTR(obj.details);
        } else if (this.trData && this.trData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name ==
                "Telephone Reimbursement"
              : element.name == "Telephone Reimbursement"
          );
          this.Exemption10.others[index].file_location = this.trData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.trData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.trData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveIR(obj) {
      await this.saveIRData(obj);
    },
    setIRData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name == "Internet Reimbursement"
            : element.name == "Internet Reimbursement"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveIR(obj.details);
        } else if (this.irData && this.irData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name == "Internet Reimbursement"
              : element.name == "Internet Reimbursement"
          );
          this.Exemption10.others[index].file_location = this.irData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.irData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.irData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveDS(obj) {
      await this.saveDSData(obj);
    },
    setDSData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name ==
              "Driver Salary Reimbursement"
            : element.name == "Driver Salary Reimbursement"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveDS(obj.details);
        } else if (this.driverData && this.driverData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name ==
                "Driver Salary Reimbursement"
              : element.name == "Driver Salary Reimbursement"
          );
          this.Exemption10.others[index].file_location = this.driverData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.driverData[this.$route.query.id].salaryList.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.driverData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveBP(obj) {
      await this.saveBPData(obj);
    },
    setBPData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name == "Books & Periodicals"
            : element.name == "Books & Periodicals"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveBP(obj.details);
        } else if (this.bpData && this.bpData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element => element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name == "Books & Periodicals"
              : element.name == "Books & Periodicals"
          );
          this.Exemption10.others[index].file_location = this.bpData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.bpData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.bpData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveCEA(obj) {
      await this.saveCEAData(obj);
    },
    setCEAData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name ==
              "Children Education Allowance"
            : element.name == "Children Education Allowance"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveCEA(obj.details);
        } else if (this.ceaData && this.ceaData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name ==
                "Children Education Allowance"
              : element.name == "Children Education Allowance"
          );
          this.Exemption10.others[index].file_location = this.ceaData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.ceaData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.ceaData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveHFA(obj) {
      await this.saveHFAData(obj);
    },
    setHFAData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name == "Hostel Fee Allowance"
            : element.name == "Hostel Fee Allowance"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveHFA(obj.details);
        } else if (this.hfaData && this.hfaData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name == "Hostel Fee Allowance"
              : element.name == "Hostel Fee Allowance"
          );
          this.Exemption10.others[index].file_location = this.hfaData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.hfaData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.hfaData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveRA(obj) {
      await this.saveRAData(obj);
    },
    setRAData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name == "Relocation Allowance"
            : element.name == "Relocation Allowance"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveRA(obj.details);
        } else if (this.raData && this.raData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name == "Relocation Allowance"
              : element.name == "Relocation Allowance"
          );
          this.Exemption10.others[index].file_location = this.raData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.raData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.raData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async savePD(obj) {
      await this.savePDData(obj);
    },
    setPDData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name == "Professional Development"
            : element.name == "Professional Development"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.savePD(obj.details);
        } else if (this.pdData && this.pdData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name ==
                "Professional Development"
              : element.name == "Professional Development"
          );
          this.Exemption10.others[index].file_location = this.pdData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.pdData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.pdData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveBE(obj) {
      await this.saveBEData(obj);
    },
    setBEData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name == "Business Entertainment"
            : element.name == "Business Entertainment"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveBE(obj.details);
        } else if (this.beData && this.beData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name == "Business Entertainment"
              : element.name == "Business Entertainment"
          );
          this.Exemption10.others[index].file_location = this.beData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.beData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.beData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async saveFNM(obj) {
      await this.saveFNMData(obj);
    },
    setFNMData() {
      try {
        let obj = this.Exemption10.others.find(element =>
          element.InvestmentComponentType
            ? element.InvestmentComponentType.name ==
              "Fuel & Maintenance Reimbursement"
            : element.name == "Fuel & Maintenance Reimbursement"
        );
        if (obj.details && Object.keys(obj.details).length) {
          this.saveFNM(obj.details);
        } else if (this.fnmData && this.fnmData[this.$route.query.id]) {
          let index = this.Exemption10.others.findIndex(element =>
            element.InvestmentComponentType
              ? element.InvestmentComponentType.name ==
                "Fuel & Maintenance Reimbursement"
              : element.name == "Fuel & Maintenance Reimbursement"
          );
          this.Exemption10.others[index].file_location = this.fnmData[
            this.$route.query.id
          ].proofs;

          let sum = 0;
          this.fnmData[this.$route.query.id].data.forEach(element => {
            sum += element.amount;
          });
          this.Exemption10.others[index].actual = sum;
          this.Exemption10.others[index].details = this.fnmData[
            this.$route.query.id
          ];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async submitData() {
      try {
        let obj = {
          previousEmploymentDetails: this.previousEmploymentDetails,
          deductionsUnderSection16: this.deductionsUnderSection16,
          section24: this.section24,
          otherIncome: this.otherIncomeList,
          deductionsUnderChapterVIA: [
            ...this.chapterDataList,
            ...this.chapterOtherDataList
          ],
          exeption10: this.Exemption10,
          tds_breakup_and_taxable_income: this.tds_breakup_and_taxable_income,
          employee_id: this.$route.query.id,
          financial_year: "2019",
          le_id: this.le_id
        };
        let res = await this.act_submitITDeclarationData({ data: obj });
        if (res.data.status) {
          this.$router.push({
            path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/importdeclarations`,
            query: { id: this.$route.query.id, status: "download" }
          });
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    back() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/ITdeclarations`
      });
    },
    addDependantDetails() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/dependent`,
        query: { id: this.$route.query.id }
      });
    },
    openDocModal(docList, index, section) {
      try {
        if (docList.length) {
          this.docsList = docList;
          this.docIndex = 0;
          this.index = 0;
          this.docUrl = this.docsList[0];
          this.currentDocIndex = index;
          this.showDocModal = true;
          this.currentFileSection = section;
        }
        if (section == "Section10") {
          this.showDeleteDoc = false;
        } else {
          this.showDeleteDoc = true;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    prev() {
      try {
        if (this.index) {
          this.index = this.index - 1;
          this.docUrl = this.docsList[this.index];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    next() {
      try {
        if (this.index < this.docsList.length - 1) {
          this.index = this.index + 1;
          this.docUrl = this.docsList[this.index];
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteDoc(index) {
      try {
        let url = this.docsList[index];
        if (this.currentFileSection == "chapter-others") {
          let idx = this.chapterOtherDataList[
            this.currentDocIndex
          ].file_location.findIndex(item => item == url);
          this.chapterOtherDataList[this.currentDocIndex].file_location.splice(
            idx,
            1
          );
        }
        if (this.currentFileSection == "chapter-80C") {
          let idx = this.chapterDataList[
            this.currentDocIndex
          ].file_location.findIndex(item => item == url);
          this.chapterDataList[this.currentDocIndex].file_location.splice(
            idx,
            1
          );
        }
        if (this.currentFileSection == "other-income") {
          let idx = this.otherIncomeList[this.currentDocIndex].proof.findIndex(
            item => item == url
          );
          this.otherIncomeList[this.currentDocIndex].proof.slice(idx, 1);
        }
        if (this.currentFileSection == "letout") {
          let idx = this.section24.let_out_property[
            this.currentDocIndex
          ].proof.findIndex(item => item == url);
          this.section24.let_out_property[this.currentDocIndex].proof.splice(
            idx,
            1
          );
        }
        if (this.currentFileSection == "self-occupied") {
          let idx = this.section24.self_occupied.proof.findIndex(
            item => item == url
          );
          this.section24.self_occupied.proof.splice(idx, 1);
        }
        if (this.currentFileSection == "tds") {
          let idx = this.previousEmploymentDetails.tds.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.tds.location.splice(idx, 1);
        }
        if (this.currentFileSection == "nps") {
          let idx = this.previousEmploymentDetails.nps.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.nps.location.splice(idx, 1);
        }
        if (this.currentFileSection == "pf") {
          let idx = this.previousEmploymentDetails.pf.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.pf.location.splice(idx, 1);
        }
        if (this.currentFileSection == "vpf") {
          let idx = this.previousEmploymentDetails.vpf.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.vpf.location.splice(idx, 1);
        }
        if (this.currentFileSection == "pt") {
          let idx = this.previousEmploymentDetails.pt.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.pt.location.splice(idx, 1);
        }
        if (this.currentFileSection == "salary-income") {
          let idx = this.previousEmploymentDetails.salary_income.location.findIndex(
            item => item == url
          );
          this.previousEmploymentDetails.salary_income.location.splice(idx, 1);
        }
        this.docsList.splice(index, 1);
        if (index < this.docsList.length) {
          this.docUrl = this.docsList[index];
        } else if (index >= this.docsList.length) {
          if (!index && !this.docsList.length) {
            this.docUrl = "";
            this.showDocModal = false;
          } else {
            this.docUrl = this.docsList[index - 1];
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    okbtn() {
      this.showModal = false;
      this.showDocModal = false;
    },
    addMoreLetOut() {
      try {
        this.section24.let_out_property.push({
          letOut: [],
          total_planned: 0,
          total_actual: 0,
          proof: [],
          joint_holder_name: "",
          relationship: "",
          tax_benefit: 0
        });
        this.calculateLetOutFy();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteLetOut(index) {
      try {
        this.section24.let_out_property.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreHouse() {
      try {
        this.Exemption10.HRA.push({
          address: "",
          pincode: "",
          State: "",
          cityType: "metro",
          rentList: [
            {
              rentFrom: "",
              rentTo: "",
              amount: "",
              agreementDoc: ""
            }
          ],
          ownerDetails: {
            name: "",
            pan_number: "",
            pincode: "",
            address: "",
            state: "",
            pancardUrl: "",
            isCoOwner: false,
            cownerDetails: {
              name: "",
              pan_number: "",
              pincode: "",
              address: "",
              state: "",
              pancardUrl: ""
            }
          }
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteHouse(index) {
      try {
        this.Exemption10.HRA.splice(index, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    addMoreDate(houseIndex) {
      try {
        this.Exemption10.HRA[houseIndex].rentList.push({
          rentFrom: "",
          rentTo: "",
          amount: "",
          agreementDoc: ""
        });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    deleteDate(houseIndex, dateIndex) {
      try {
        this.Exemption10.HRA[houseIndex].rentList.splice(dateIndex, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async uploadPanCard(docFile, index, type) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              if (type == "owner") {
                this.Exemption10.HRA[index].ownerDetails.pancardUrl =
                  res.data.location;
                this.Exemption10.HRA[index].ownerDetails.fileName =
                  docFile.name;
              } else {
                this.Exemption10.HRA[
                  index
                ].ownerDetails.cownerDetails.pancardUrl = res.data.location;
                this.Exemption10.HRA[
                  index
                ].ownerDetails.cownerDetails.fileName = docFile.name;
              }
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async uploadRentAggr(docFile, index, idx) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              this.Exemption10.HRA[index].rentList[idx].agreementDoc =
                res.data.location;
              this.Exemption10.HRA[index].rentList[idx].fileName = docFile.name;
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async uploadFile(docFile, index, category) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              if (category == "otherIncome") {
                this.otherIncomeList[index].proof.push(res.data.location);
              }
              if (category == "Section24-self") {
                this.section24.self_occupied.proof.push(res.data.location);
              }
              if (category == "Section24-letout") {
                this.section24.let_out_property[index].proof.push(
                  res.data.location
                );
              }
              if (category == "chapterVIAOthers") {
                if (this.chapterOtherDataList[index].file_location == null) {
                  this.chapterOtherDataList[index].file_location = [];
                }
                this.chapterOtherDataList[index].file_location.push(
                  res.data.location
                );
              }
              if (category == "chapterVIA") {
                if (this.chapterDataList[index].file_location == null) {
                  this.chapterDataList[index].file_location = [];
                }
                this.chapterDataList[index].file_location.push(
                  res.data.location
                );
              }
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    async uploadPEProof(docFile, item) {
      try {
        if (docFile) {
          if (docFile.size > parseInt(this.maxSize)) {
            this.$emit("bigFileSize");
          } else {
            this.file = docFile;
            let formData = new FormData();
            formData.append("file", docFile);
            // multipart
            let res = await axios_instance.post("", formData);
            if (res.data.status) {
              this.previousEmploymentDetails[item].location.push(
                res.data.location
              );
            }
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    toggleContent(accordianType) {
      try {
        switch (accordianType) {
          case "employmentDetails":
            this.showEmploymentDetailsAccordionBody = !this
              .showEmploymentDetailsAccordionBody;
            break;
          case "sectionTen":
            this.showSectionTenAccordionBody = !this
              .showSectionTenAccordionBody;
            break;
          case "houseRent":
            this.showHouseRentAccordionBody = !this.showHouseRentAccordionBody;
            break;
          case "chapter6A":
            this.showChapter6AAccordionBody = !this.showChapter6AAccordionBody;
            break;

          default:
            this.showOtherIncomeAccordionBody = !this
              .showOtherIncomeAccordionBody;

            break;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.employee-card {
  display: grid;
  grid-template-columns: 50px auto;

  grid-gap: 18px;
  width: 427px;
  opacity: 0.8;
  border-radius: 10px;
  border: solid 1px #cccfce;
  background-color: #ffffff;
  padding: 23px;
  img {
    width: 55px;
    height: 55px;
    opacity: 0.8;
    border-radius: 41px;
  }
  .card-details {
    .code {
      margin-bottom: 2px;
      color: #979797;
      font-size: 12px;
    }
    p {
      margin-bottom: 5px;
    }
    .year-data {
      font-size: 14px;
      font-weight: 500;
      line-height: normal;
      letter-spacing: normal;
      color: #535353;
    }
  }
}
.close-btn {
  margin-top: 15px;
  color: #34c0be;
  text-decoration: none;
  font-weight: 500;
}
.dependent-btn {
  float: right;
  color: #37c6c0;
  font-weight: 600;
  margin-top: 15px;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  span {
    top: -6px;
    left: 5px;
    position: relative;
  }
}
.delete-btn {
  color: #37c6c0;
  font-weight: 600;
  margin-top: 15px;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
  span {
    top: -3px;
    left: 10px;
    position: relative;
  }
}
// accordian

.it_accordHeading {
  padding-left: 35px;
  padding-bottom: 5px;
  position: relative;
  cursor: pointer;
  border-bottom: 2px solid #e6e6e6;
  &:before {
    content: "\2010";
    position: absolute;
    color: #37c6c0;
    left: 10px;
    bottom: -10px;
    font-size: 40px;
  }
}
.it-payroll__accordBlock {
  .accordContent {
    display: none !important;
  }
  &.active {
    display: block;
    .accordContent {
      display: block !important;
    }
  }
}
.d-heading2 {
  font-size: 14px;
  color: #646464;
  font-weight: 600;
  border-bottom: none;
}
.attach_file {
  width: 35px;
  text-align: center;
  padding: 7px 14px;
  height: 35px;
  border-radius: 50%;
  background-color: #d8d8d8;
}
label.fileLabel input[type="file"] {
  opacity: 0;
  width: 0px;
  height: 0px;
  position: absolute;
  pointer-events: none;
}
label.fileLabel {
  color: #646464;
  text-decoration: underline;
  cursor: pointer;
  img {
    width: 10px;
  }
  .attachment {
    width: 20px;
  }
  .plus-icon {
    width: 25px;
    visibility: hidden;
  }
}
.docImage {
  width: 100%;
  height: 350px;
}
.inline-flex {
  display: inline-flex;
}

.group-heading {
  background-color: #d8d8d8;
  padding: 10px 10px;
  margin-bottom: 10px;
  font-weight: 600;
}
.datatable-outer-container {
  width: 100%;
  table.datatable {
    width: 100%;
    border-collapse: collapse;
    margin: 0 auto;
    font-family: Montserrat;
    margin-bottom: 4px;
    //   table-layout: fixed;

    .header-row {
      background-color: white;
      height: 54px;
      th {
        background-color: #f0f1f5;
        border-bottom: 0px solid #34c0be;
        padding: 6px 8px;
        //   text-align: center;
      }
    }
    .inactiveCols {
      opacity: 0.03;
      background-color: #a2a1a1;
    }
    // for datatable2
    .Editdeleteheader {
      background-color: #ffffff;
      box-shadow: 0 2px 6px 0 rgba(52, 192, 190, 0.5);

      th {
        // border-right: 1px solid #ececec;
        padding: 0 8px;
        // display: flex;
        span {
          border-right: 1px solid #ececec;
          padding: 0px 18px 0px 15px;
          display: inline-block;
          vertical-align: middle;
          &:first-child {
            padding: 10px 10px 7px 10px;
          }
        }
        &:last-of-type {
          text-align: right;
          span {
            border-right: none;
            font-weight: 400;
            font-style: italic;
            position: relative;
            //    display: block;
            i {
              position: absolute;
              right: 10px;
              top: 2px;
            }
          }
        }
      }
    }
    .record-row {
      height: 54px;
      border-bottom: 0px solid #d8d8d8;
      //   text-align: center;
      &:nth-child(odd) {
        background-color: #f5f6fa;
      }
      &.selectedRecord {
        background-color: #e9f9f8;
        opacity: 0.9;
      }

      td {
        padding: 6px 8px;
        color: #000000;
      }

      .action-img {
        display: block;
        cursor: pointer;
        opacity: 0.1;
      }

      &:hover {
        .action-img {
          opacity: 1;
        }
        .plus-icon {
          visibility: visible;
        }
      }
    }
  }
}

.arrow {
  position: fixed;
  top: 0;
  display: block;
  width: 50px;
  height: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  /* Let's put our arrow to go back on the left. */
  &.arrow-prev {
    left: 400px;
    background-color: #fff;
    height: 50px;
    text-align: center;
    border-radius: 50%;
    font-size: 40px;
    font-weight: 500;
    color: #34c0be;
    text-decoration: none;
    top: 50%;
    vertical-align: middle;
  }

  /* And our arrow to go forward on the right. Since I'm using
      the same arrow image for both my arrows, I'm rotating this one by
      180 degrees so that it points in the right direction */
  &.arrow-next {
    right: 400px;
    background-color: #fff;
    text-align: center;
    border-radius: 50%;
    height: 50px;
    font-size: 40px;
    text-decoration: none;
    font-weight: 500;
    color: #34c0be;
    top: 50%;
  }
}
.header-table {
  background-color: #f0f1f5;
}
.table-header {
  display: inline-flex;
  width: 100%;
  padding: 10px 0px;
  .table-header-item {
    padding: 5px 10px;
    width: 100%;
    color: #000000;
    opacity: 0.68;
    font-weight: 500;
  }
}
.row-div {
  &:nth-child(odd) {
    background-color: #f5f6fa;
  }
}
.table-row {
  display: inline-flex;
  width: 100%;
  padding: 10px 0px;
  &:hover {
    .action-img {
      opacity: 1;
    }
    .plus-icon {
      visibility: visible;
    }
  }
  .table-row-item {
    padding: 5px 10px;
    width: 100%;
    color: #000000;
    opacity: 0.68;
    font-weight: 500;
    a {
      color: blue;
      text-decoration: underline;
    }
  }
  .text-center {
    text-align: center;
  }
}
.btn-close {
  padding: 0px;
  margin-left: 10px;
  min-height: 40px;
  min-width: 75px;
  width: 100px;
  float: right;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
</style>
